import {Component, Input, AfterViewInit, AfterContentChecked} from "@angular/core";
import {BaseDataType} from "../../base-data-type";
import {FormGroup} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {AbstractViewComponent} from "../abstract-view/abstract-view.component";
import {Utils} from "../../util/Utils";
import {LabelType} from "../../label-type";

@Component({
    selector: "app-check-button-list",
    templateUrl: "./check-button-list.component.html",
    styleUrls: ["./check-button-list.component.scss"]
})
export class CheckButtonListComponent extends AbstractViewComponent implements AfterContentChecked {

    public readonly TAG: string = "[CheckButtonListComponent]";

    public typeId: string;

    /**
     * If defined, stores selected value in a 'storeKey:value' mode
     * in the values array.
     *
     * Used for belrivDimensions.
     */
    @Input() storeKey: string;

    private _types: BaseDataType[];

    public type: BaseDataType;
    private typeForm: FormGroup;

    public selectedValues: any[];
    public selectedOptions: any[];

    public noOptionSelected: any;

    public disabledType: any;

    /**
     * Used only for monoselection mode, to show options.
     */
    public selectedType: BaseDataType;
    public selectedTypeOption: BaseDataType;

    /**
     * Main form data dictionary.
     */
    public valuesDictionary: { [key: string]: number };

    constructor(protected route: ActivatedRoute) {
        super(route);
    }

    ngAfterContentChecked() {
        // Force to show options and error message on reload
        if(this.selectedValues && this.selectedValues[0] === "hampe_galvanisee") {
            this.selectedType = this.types.find(t => t.id === this.selectedValues[0]);

            if(this.selectedOptions.length === 0) {
                this.noOptionSelected = this.selectedValues[0];
            }
        }
    }

    @Input()
    public set types(pValue: BaseDataType[]) {
        this._types = pValue;

        console.log(this.typeId);

        if (this.typeId === undefined) {
            if (this.route.snapshot.url.length >= 3) {
                this.typeId = this.route.snapshot.url[3].path;
            }
        }

        this.selectedValues = this.confDataService.getElementValues(this.typeId) || [];
        this.selectedOptions = this.confDataService.getElementOptions(this.typeId) || [];
        console.log(this.TAG, "set types", this.selectedValues, this.selectedOptions);

        if (this.selectedValues.indexOf("closoir") > -1) {
            this.disabledType = "stop-piafs";
        } else if (this.selectedValues.indexOf("stop-piafs") > -1) {
            this.disabledType = "closoir";
        }
    }

    public get types(): BaseDataType[] {
        return this._types;
    }

    /**
     * Check if all conditions are filled, to show navigation element.
     *
     * @see {@link README.md#Conditions} for further information.
     * @param pType {BaseDataType}
     */
    private conditionsValidated(pType: BaseDataType): boolean {
        return Utils.conditionsValidated(pType);
    }

    /**
     * Values are saved in confDataService.
     *
     * @param pId {string}
     */
    protected onTypeSelected(pId: string): void {
        console.log(this.TAG, "onTypeSelected()", pId);

        this.noOptionSelected = null;

        let index: number;
        // This switch allows to configure if we can choose one or multiple elements.
        switch (this.typeId) {
            // Multiselection
            case "accessories-type":
                index = this.selectedValues.indexOf(pId);

                if(pId == "closoir") {
                    // t.options && t.options[0] && t.options[0].required === true
                    console.log("AccessoriesTypeComponent", pId);

                    if(index === -1) {
                        this.disabledType = "stop-piafs";
                    } else {
                        this.disabledType = "";
                    }
                } else if(pId == "stop-piafs") {
                    console.log("AccessoriesTypeComponent", pId);
                    if(index === -1) {
                        this.disabledType = "closoir";
                    } else {
                        this.disabledType = "";
                    }
                }

                index === -1 ? this.selectedValues.push(pId) : this.selectedValues.splice(index, 1);
                break;

            case "belriv-dimensions":
                this.selectedValues = this.confDataService.getElementValues(this.typeId) || [];
                if (this.selectedValues[0] === undefined) {
                    this.selectedValues[0] = {};
                }
                // IF storeKey contains the 'width' string, like in 'belriv-dimensions-facade-tradi-width',
                // we search for a selected same section (pignon or facade) height value,
                // and delete it to invalidate the form.
                if (this.storeKey.indexOf("width") !== -1) {
                    const section: string = this.storeKey.indexOf("facade") !== -1 ? "facade" : "pignon";
                    for (const key in this.selectedValues[0]) {
                        if (key !== this.storeKey && key.indexOf(section) !== -1) {
                            delete this.selectedValues[0][key];
                            break;
                        }
                    }
                }
                this.selectedValues[0][this.storeKey] === pId ? delete this.selectedValues[0][this.storeKey] : this.selectedValues[0][this.storeKey] = pId;
                break;

            // Monoselection
            default:
                this.selectedValues = [pId];
                this.selectedType = this.types.find(type => type.id === pId);
                break;
        }

        console.log(this.TAG, "onTypeSelected()", this.selectedValues);

        this.confDataService.updateElementValues(this.typeId, this.selectedValues);
    }

    /**
     * Values are saved in confDataService.
     *
     * @param pId {string}
     */
    protected onTypeOptionSelected(pId: string, parentId: string = null ): void {
        console.log(this.TAG, "onTypeOptionsSelected()", pId);

        this.selectedOptions = [pId];
        if(parentId === "hampe_galvanisee") {

            //this.selectedType = this.types.find(type => type.id === parentId);
            console.log(this.TAG, "onTypeOptionsSelected()", this.types.find(type => type.id === parentId));
        }

        this.confDataService.updateElementOptions(this.typeId, this.selectedOptions);
    }

    private handleError(error: any): void {
        console.error(this.TAG, "An error occurred", error);
    }

    public getData(): void {
        super.getData();

        if (this.route.snapshot.url.length >= 3) {
            this.typeId = this.route.snapshot.url[3].path;
        }

        if (this.typeId === undefined) {
            return;
        }

        this.appService.getData(this.confDataService.getApiUrl(this.typeId))
            .then(types => this.types = types);
    }

    /**
     * Return the current state (checked or not) to the checkbox button.
     *
     * @param pType {BaseDataType}
     * @param pStoreKey {string}
     */
    public typeSelected(pType: BaseDataType, pStoreKey: string, pOption: boolean = false): boolean {
        // console.log(this.TAG, "typeSelected()", pType.id, pStoreKey, pOption);


        // hampe_galvanisee -> pType.id == selectedOptions // Monoselection
        if(this.selectedValues[0] === "hampe_galvanisee" && pOption) {
            return (pType.id == this.selectedOptions[0]);
        }

        if (this.selectedValues.indexOf(pType.id) !== -1 || ( pStoreKey && this.selectedValues[0] && this.selectedValues[0][pStoreKey] === pType.id )) {
            return true;
        }

        // If the element is not already selected and is an obligatory one (required in the json file),
        // we save it in confdata.
        if (pType.options && pType.options[0] && pType.options[0].required === true) {
            pOption === false ? this.onTypeSelected(pType.id) : this.onTypeOptionSelected(pType.id);
            return true;
        }

        return false;
    }

    /**
     * Show element's complementary information
     *
     * @param pInfo {LabelType}
     */
    public showInfo(pInfo: LabelType): void {
        window.open(pInfo[this.lang], "_blank");
    }

    protected onClickValidate(e: MouseEvent): void
    {
        console.log(this.TAG, "onClickValidate()", e);

        if(this.selectedValues.length === 0) {
            console.log(this.TAG, "no value select");
        } else if(this.selectedOptions.length === 0) {
            let selectValue = this.types.find(type => type.id === this.selectedValues[0]);
            if(selectValue.no_option === undefined) {
                this.nextRoute();
            } else {
                this.noOptionSelected = this.selectedValues[0];
            }
        } else {
            this.nextRoute();
        }
    }

    private nextRoute(): void {
        console.log(this.TAG, this.route.snapshot);

        const commands: string[] = ["/lang", this.lang, this.route.snapshot.url[2].toString(), ""];

        this.router.navigate(commands);
    }
}



// WEBPACK FOOTER //
// ./src/app/main-view/check-button-list/check-button-list.component.ts